import shape from "../../assets/img/shapes/left-shape-02.webp";


const LeftShape02 = () => {

    return (
        <div className="rmdr-left-shape-02">
            <img src={shape} alt="rmdr-left-shape-02" loading="lazy" width={253} height={350} />
        </div>
    )

}

export default LeftShape02;
